import {
  ApparelProduct,
  GDMState,
  GraphicComponent,
  GraphicComponentTypes,
  GraphicPlacement,
  GraphicProduct,
  IGraphicGDM,
  iGraphicUGC,
  PlacementTypes,
} from "@/libs/graphics/types/Graphics.t";

/**
 * The GDM getters interface.
 */
export type GettersGDM = {
  /**
   * Returns the ugc data from the GDM for a given component and subcomponent
   * @param {PlacementTypes} component
   * @param {GraphicComponentTypes} subcomponent
   */
  getComponentUgcData(
    state: GDMState
  ): (component: PlacementTypes, subcomponent: GraphicComponentTypes) => iGraphicUGC | undefined;

  /**
   * Returns the graphic data from the GDM for a given component
   * @param {PlacementTypes} component
   * @return {IGraphicGDM | undefined} graphic
   */
  getGraphicByComponent(
    state: GDMState
  ): (component: PlacementTypes) => IGraphicGDM | undefined;

  getActiveSubcomponentIDs(
    state: GDMState,
    getters: GettersGDM,
    rootState: any
  ): (isUGCEnabled: boolean) => GraphicComponentTypes[]

  getGraphicsTransform(
    state: GDMState,
    getters: GettersGDM,
    rootState: any
  ): (component: PlacementTypes) => Partial<CSSStyleDeclaration> | undefined
};

const getters: GettersGDM = {
  getComponentUgcData: (state: GDMState) => (component: PlacementTypes, subcomponent: GraphicComponentTypes) => {
    return state.data
      ?.find(
        (graphic: IGraphicGDM) => component === graphic.component3D
      )
      ?.component?.find(
        (component: GraphicComponent) =>
          component.id === subcomponent
      )?.ugc;
  },
  getGraphicByComponent: (state: GDMState) => (component: PlacementTypes) => {
    return state.data
      ?.find(
        (graphic: IGraphicGDM) => component === graphic.component3D
      );
  },
  getActiveSubcomponentIDs: (state, getters, rootState) => (isUGCEnabled: boolean = false) => {
    const activeComponent = rootState.standardNavigation.activeComponent
    const activeGraphic = state.data
      ?.find(
        (graphic: IGraphicGDM) => activeComponent === graphic.component3D
      );

    return isUGCEnabled === true
      ? activeGraphic?.component?.filter(n => n.ugc_enable === true).map(a => a.id) as GraphicComponentTypes[]
      : activeGraphic?.component?.map(a => a.id) as GraphicComponentTypes[]
  },
  getGraphicsTransform: (state, getters, rootState) => (component: PlacementTypes) => {
    const targetComponent: PlacementTypes = component === 'graphic_sleeve_left' ? 'graphic_sleeve_right' : component
    const sku: ApparelProduct = rootState.utils.pdm.sku
    const activeGraphic = state.data
      ?.find(
        (graphic: IGraphicGDM) => targetComponent === graphic.component3D
      );
    const activeProduct = activeGraphic?.product?.find(
      (product: GraphicProduct) => product.productID === sku
    )
    const activePlacement = activeProduct?.placement.find(
      (placement: GraphicPlacement) => placement.placementID === component
    )
    const transform = activePlacement?.transform
    return transform
  }
};

export default getters;
